<template>
  <div class="d-flex gap-1">
    <!-- TODO: check unsuporrted prop: offset-y -->
    <v-menu
      v-model="showDatePicker"
      :close-on-content-click="false"
      :offset="40"
      transition="scale-transition"
      min-width="auto"
      :style="{ 'z-index': '99999' }"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :model-value="formattedDate"
          prepend-inner-icon="mdi-calendar"
          variant="outlined"
          readonly
          density="compact"
          hide-details
          data-testid="content-creator-schedule-date"
          v-bind="props"
        />
      </template>
      <v-date-picker
        v-model="selectedDate"
        :min="startOfDay(new Date())"
        @update:model-value="dateChanged"
      />
    </v-menu>
    <!-- TODO: check unsuporrted prop : offset-y -->
    <v-menu
      ref="menu"
      v-model="showTimePicker"
      :close-on-content-click="false"
      :offset="40"
      transition="scale-transition"
      max-width="290px"
      min-width="290px"
      :style="{ 'z-index': '99999' }"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :model-value="selectedTime"
          prepend-inner-icon="mdi-clock-time-four-outline"
          readonly
          variant="outlined"
          density="compact"
          hide-details
          data-testid="content-creator-schedule-time"
          v-bind="props"
        />
      </template>
      <v-time-picker
        v-if="showTimePicker"
        v-model="selectedTime"
        full-width
        format="24hr"
        :min="minTime"
        @update:hour="hourChanged"
        @update:minute="minuteChanged"
      />
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: () => new Date().toISOString(),
    },
  },

  data() {
    return {
      showDatePicker: false,
      showTimePicker: false,
      selectedDate: this.getDateFromValue(),
      selectedTime: '00:00',
    }
  },
  computed: {
    minTime() {
      if (!this.isToday) return null
      return new Date().toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
    },
    isToday() {
      const today = this.startOfDay(new Date())
      const selected = this.startOfDay(new Date(this.selectedDate))
      return today.getTime() === selected.getTime()
    },
    formattedDate() {
      try {
        return new Date(this.value).toLocaleDateString()
      } catch {
        return new Date().toLocaleDateString()
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        try {
          const date = new Date(newValue)
          this.selectedDate = date
          this.selectedTime = date.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          })
        } catch {
          const now = new Date()
          this.selectedDate = now
          this.selectedTime = now.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          })
        }
      },
    },
  },
  methods: {
    startOfDay(date) {
      const newDate = new Date(date)
      newDate.setHours(0, 0, 0, 0)
      return newDate
    },
    getDateFromValue() {
      try {
        return new Date(this.value)
      } catch {
        return new Date()
      }
    },
    emitUpdate(date) {
      this.$emit('input', date.toISOString())
    },
    dateChanged(newDate) {
      if (!newDate) return

      const currentDate = new Date(this.value)
      const [hours, minutes] = this.selectedTime.split(':').map(Number)

      currentDate.setFullYear(newDate.getFullYear())
      currentDate.setMonth(newDate.getMonth())
      currentDate.setDate(newDate.getDate())
      currentDate.setHours(hours)
      currentDate.setMinutes(minutes)

      this.selectedDate = newDate
      this.emitUpdate(currentDate)
      this.showDatePicker = false
    },
    hourChanged(hour) {
      const currentDate = new Date(this.value)
      const [, minutes] = this.selectedTime.split(':').map(Number)

      currentDate.setHours(hour)
      currentDate.setMinutes(minutes)

      this.emitUpdate(currentDate)
    },
    minuteChanged(minute) {
      const currentDate = new Date(this.value)
      const [hours] = this.selectedTime.split(':').map(Number)

      currentDate.setHours(hours)
      currentDate.setMinutes(minute)

      this.emitUpdate(currentDate)
    },
  },
  emits: ['input'],
}
</script>

<style scoped>
:deep(.v-card > *:first-child:not(.v-btn):not(.v-chip):not(.v-avatar)),
:deep(.v-card > *:last-child:not(.v-btn):not(.v-chip):not(.v-avatar)) {
  border-radius: 0;
}
:deep(.v-time-picker-controls__time) button {
  height: unset !important;
}
</style>
